import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");


export const getListLivraison = createAsyncThunk("livraison/listLivraison", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "livraison/listLivraison", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
    body: JSON.stringify(action),
  });
  const livraison = await response.json();
  return livraison;
});


export const getListCommandeLivraison = createAsyncThunk("livraison/getListCommandeLivraison", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "livraison/getListCommandeLivraison", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
    body: JSON.stringify(action),
  });
  const livraison = await response.json();
  return livraison;
});



export const allLivraison = createAsyncThunk("livraison/allLivraison", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "livraison/allLivraison", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
    body: JSON.stringify(action),
  });
  const livraison = await response.json();
  return livraison;
});



export const getLivraisonById = createAsyncThunk("livraison/getLivraisonById", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "livraison/getLivraisonById/" + id, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const livraison = await response.json();
  return livraison;
});



export const getLivCommande = createAsyncThunk("livraison/getLivCommande", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "livraison/getLivCommande/" + id, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const livraison = await response.json();
  return livraison;
});



//getDetailLivraison
export const getDetailLivraison = createAsyncThunk("livraison/getDetailLivraison", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "livraison/getDetailLivraison/" + id, {
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const livraison = await response.json();
  return livraison;
});
//getDetailLivraison
export const getDetailLivraisonCommande = createAsyncThunk("livraison/getDetailLivraisonCommande", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "livraison/getDetailLivraisonCommande/" + action.idLivraison+'/'+action.numCmd, {
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const livraison = await response.json();
  return livraison;
});

export const getLotArticle = createAsyncThunk("livraison/getLotArticle", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "livraison/getLotArticle/"+action.CodeProduit, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
  });
  const livraison = await response.json();
  return livraison;
});

export const getBlLot = createAsyncThunk("livraison/getBlLot", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "livraison/getBlLot/"+action.lot, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
  });
  const livraison = await response.json();
  return livraison;
});



export const getListEnteteLivraison = createAsyncThunk("livraison/getListEnteteLivraison", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "livraison/getListEnteteLivraison", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const livraison = await response.json();
  return livraison;
});



const livraisonReduce = createSlice({
  name: "livraison",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {




  },
  extraReducers: {

  },
});

export const { } = livraisonReduce.actions;

export default livraisonReduce.reducer;
